import { render } from "./MPromotionRules.vue?vue&type=template&id=4f432bdf&scoped=true"
import script from "./MPromotionRules.vue?vue&type=script&lang=js"
export * from "./MPromotionRules.vue?vue&type=script&lang=js"

import "./MPromotionRules.vue?vue&type=style&index=0&id=4f432bdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f432bdf"]])

export default __exports__